
import "C:/GIT/CODE/dartsCloud/web/darts/src/components/TeamDropdown/conponents/JoinTeamModal/index.less?modules";
export default {"rightContent": `rightContent-FSKWpCzc`,"modalContent": `modalContent-ojrP1dN8`,"createTeamModal": `createTeamModal-syrxTZyE`,"buttonGroup": `buttonGroup-Xgl80q2m`,"leftContent": `leftContent-SkZ1a0R9`}
